// Add, edit, or remove topics here.
// - `label`: what the user sees as the button
// - `answer`: pre-defined response shown before asking them to type. Leave out (or set to undefined) to go straight to the message input.

export interface SupportTopic {
  label: string;
  answer?: string;
}

const supportTopics: SupportTopic[] = [
  {
    label: 'How do I upload my manuscript?',
    answer:
      'In the Book Formatting step, you can paste your content directly or upload a .docx file. Make sure each chapter has a clear title — we use those to automatically build your table of contents.',
  },
  {
    label: 'My book was rejected — what do I do?',
    answer:
      "You'll find the rejection reason on your book page. Click 'Edit & Resubmit' on your dashboard to make the changes and resubmit for review.",
  },
  {
    label: 'How does the cover image package work?',
    answer:
      'In the Book Cover step, you can opt for our Cover Image Package. We design a professional cover for your book which you can download and upload as your cover.',
  },
  {
    label: 'How long does the review process take?',
    answer:
      "Our team typically completes the review within 3 business days. You'll be notified once it's done.",
  },
  {
    label: "I'm having a technical issue",
    // No answer — goes straight to message input
  },
  {
    label: 'Something else',
    // No answer — goes straight to message input
  },
];

export default supportTopics;
